import BasicAuthGenerator from "../utils/BasicAuthGenerator";
import UserSession from "../domain/User/UserSession";

const UserSessionService = {
    login,
    getUser,
    //relogin,
    logout,
    isAuthenticated,
    retrieveTransactingHeaders,
    retrieveRegisteringHeaders,
    //retrieveRegisteringAuth,
    getBasicAuth: getBasicAuthCredentials,
    getPrivileges,
    hasPrivilege,
    // hasAnyPrivilege,
    // checkPrivilege, checkAnyPrivilege
};
export default UserSessionService;

const api_url = process.env.REACT_APP_API_URL;

function login(username, password) {
    let basicAuthCredentials = BasicAuthGenerator.create(username, password);
    return loginWithCredentials(basicAuthCredentials);

}

function loginWithCredentials(basicAuthCredentials) {

    let requestParams = {
        method: "GET",
        headers: new Headers({
            'Authorization': basicAuthCredentials,
            'Accept': 'application/json',
        }),
    };

    return fetch(api_url + "/authentication/web-agent", requestParams).then(
        response => {
            if (response.status === 200)
                return response.json();
            if (response.status === 403)
                return response.statusText;
            else
                throw Error(response.statusText);
        })
        .then(function (response) {
            return handleResponse(response, basicAuthCredentials);
        })
        .catch(handleError);
}

function logout(callback) {
    sessionStorage.clear();
    if (callback) callback();
}

function handleResponse(response, basicAuthCredentials) {
    if(response === "Forbidden")
        return response;

    let userSession = new UserSession(response);
    sessionStorage.setItem("user", userSession.toJson());
    sessionStorage.setItem("ba", basicAuthCredentials);
    return true;
}

function handleError(error) {
    return false;
}

export function getBasicAuthCredentials() {
    return sessionStorage.getItem("ba");
}

export function isAuthenticated() {
    let auth = getBasicAuthCredentials();
    return auth != null && auth.length > 0;
}

export function getUser() {
    return UserSession.fromJson(sessionStorage.getItem("user"));
}

export function getPrivileges() {
    return getUser().getPrivileges();
}

export function hasPrivilege(privilege) {
    let user_privileges = getPrivileges();
    return checkAnyPrivilege(user_privileges, [privilege]);
}
export function hasAnyPrivilege(privileges) {
    let user_privileges = getPrivileges();
    return checkAnyPrivilege(user_privileges, privileges);
}

export function checkPrivilege(privilege_list, privilege_to_look_for) {
    return privilege_list.indexOf(privilege_to_look_for) >= 0;
}

export function checkAnyPrivilege(user_privileges, allow_privileges) {
    user_privileges = user_privileges || [];
    allow_privileges = allow_privileges || [];

    for (let i = 0; i < allow_privileges.length; i++) {
        if (checkPrivilege(user_privileges, allow_privileges[i]))
            return true;
    }
    return false;
}

export function retrieveTransactingHeaders() {
    return {
        "transacting-partner-id": getUser().transactingPartnerId,
        "channel-id": getUser().transactingChannelId

    }
}

export function retrieveRegisteringHeaders() {
    let headers = {
        "registering-partner-id": getUser().registeringPartnerId,
        "registering-channel-id": getUser().registeringChannelId
    }
    return headers;
}
